import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../../API';
import * as toast from '../../components/Toast'

export const getActiveMembershipPlanDetailACTION = createAsyncThunk(
    'MembershipPlan/getActiveMembershipPlanDetail',
    async (data) => {

        return API.apiCall("/restaurant/web/membershipplan/usermembershipdetails", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        // toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);

export const getAllMembershipPlanACTION = createAsyncThunk(
    'MembershipPlan/getAllMembershipPlan',
    async (data) => {

        return API.apiCall("/restaurant/web/membershipplan/getall", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        //toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {

                return Promise.reject({
                    ...error
                })
            })
    }
);

export const membershipPlanPaymentConfirmationACTION = createAsyncThunk(
    'MembershipPlan/membershipPlanPaymentConfirmation',
    async (data) => {

        return API.apiCall("/restaurant/web/membershipplan/paymentconfirmation", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        //toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {

                return Promise.reject({
                    ...error
                })
            })
    }
);


export const membershipPlanBuyAction = createAsyncThunk(
    'MembershipPlan/membershipPlanBuy',
    async (data) => {

        return API.apiCall("/restaurant/web/membershipplan/purchase", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {

                return Promise.reject({
                    ...error
                })
            })
    }
);